export const LoginModel = {
  userId: "",
  password: "",
};

export const ResetEmailModel = {
  emailId: "",
};

export const RegisterModel = {
  firstName: "",
  lastName: "",
  emailAddress: "",
  department: "",
  permissions: "",
  title: "",
  roles: [],
};

export const NotifyModel = {
  message: "",
  position: "top-center",
  type: "",
  toggle: false,
};
